export class DashboardJsonManager {
    static makeRequestWeeklyStatus() {
        const json = {
        };

        return JSON.stringify(json);
    }
}